import * as React from "react";
import { MemoairGradientMark } from "./shared";
const SvgMemoairLogoSquare = (props) => (React.createElement(MemoairGradientMark, { ...props, gradientId: "MemoairLogoSquareGradient", from: "#31658E", to: "#47B5B8" }));
export default SvgMemoairLogoSquare;
//# sourceMappingURL=MemoairLogoSquare.js.map